export default __webpack_public_path__ + "static/article-how-do-colours-affect-your-home-8d57f8e08e1c05d8c948a13962557ed5.webp";